import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { api } from '.';
import { handleRequestError } from '../utils/request';
/********************************* Direct call ******************************** */
// Get the country and ip of the user

export var apiQueryUserIpAndCountryInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              axios.get('https://ipinfo.io/json').then(function (response) {
                resolve([response === null || response === void 0 ? void 0 : response.data, null]);
              })["catch"](function (error) {
                resolve([null, error]);
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function apiQueryUserIpAndCountryInfo() {
    return _ref.apply(this, arguments);
  };
}();
/********************************* Interface forwarding ******************************** */
// Search address

export var apiCommonSearchAddress = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/address/autocomplete", payload);

          case 3:
            res = _context2.sent;

            if (res.data) {
              res.data.addresses = (res.data.addresses || []).map(function (item) {
                return {
                  value: item.placeId,
                  label: item.address
                };
              });
            }

            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiCommonSearchAddress(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // Query address detail info

export var apiCommonSearchAddressDetailInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/address/".concat(payload.placeId));

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            payload.hideErrToast = true;
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiCommonSearchAddressDetailInfo(_x2) {
    return _ref3.apply(this, arguments);
  };
}();